<template>
  <v-icon :large="large">mdi-{{ icon }}</v-icon>
</template>

<script>
  export default {
    props: ['filename', 'large'],
    data () {
      return {
        icon: ''
      }
    },
    mounted () {
      switch (this.filename.split('.').pop().toLowerCase()) {
        case 'txt':
        case 'rtf':
          this.icon = 'file-document'
          break
        case 'xls':
        case 'xlsx':
        case 'csv':
          this.icon = 'file-excel'
          break
        case 'bmp':
        case 'jpg':
        case 'gif':
        case 'jpeg':
        case 'png':
          this.icon = 'file-image'
          break
        case 'pdf':
          this.icon = 'file-pdf'
          break
        case 'pptx':
        case 'ppt':
        case 'pptm':
        case 'pps':
        case 'ppsx':
          this.icon = 'file-powerpoint'
          break
        case 'doc':
        case 'docx':
          this.icon = 'file-word'
          break
        default:
          this.icon = 'file'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// FileIcon.vue?d74150e8